//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from "@/event-bus.js";
import { FIND_ENCUESTAS_COMPLETADAS_BY_MEDICO } from "@/graphql/queries/encuestas.js";
import { REVISAR_ENCUESTA } from "@/graphql/mutations/encuestas.js";
import { date } from "quasar";

export default {
  name: "EncuestasPendientesList",
  apollo: {
    encuestas: {
      query: FIND_ENCUESTAS_COMPLETADAS_BY_MEDICO,
      variables: {
        id_medico: null
      },
      update(data) {
        if (data.findEncuestasCompletadasByMedico) {
          return data.findEncuestasCompletadasByMedico;
        }
        return [];
      },
      skip() {
        return true;
      }
    }
  },
  mounted() {
    EventBus.$emit("page-loaded", { page: "EncuestasPendientesList" });
    let user = this.$store.getters["auth/getUser"];
    this.$apollo.queries.encuestas.setVariables({
      id_medico: +user.internal.id
    });
    this.$apollo.queries.encuestas.skip = false;
    this.$apollo.queries.encuestas.refetch();
  },
  data() {
    return {
      encuestas: [],
      columns: [
        {
          name: "dni",
          label: "DNI",
          field: row => row.paciente.dni,
          align: "left"
        },
        {
          name: "nombre_paciente",
          label: "Paciente",
          field: row =>
            `${row.paciente.nombre} ${row.paciente.primer_apellido}`,
          align: "left"
        },

        {
          name: "tipo_encuesta",
          label: "Tipo Encuesta",
          field: row => row.tipo_encuesta.descripcion,
          align: "left"
        },
        {
          name: "fill_at",
          label: "Fecha de Realización",
          field: row => this.computedDate(row.fill_at),
          align: "left"
        },
        {
          name: "estado_encuesta_nombre",
          label: "Estado Encuesta",
          align: "left",
          field: row => row.estado_encuesta.nombre
        },
        {
          name: "resultado_numerico",
          label: "Resultado Numérico",
          align: "left",
          field: "resultado_numerico"
        },
        {
          name: "options",
          label: ""
        }
      ],
      selectedEncuesta: null,
      confirmarRevisionModal: false
    };
  },
  methods: {
    showConfirmRevisarEncuesta(row) {
      this.selectedEncuesta = row.id;
      this.confirmarRevisionModal = true;
    },
    async confirmarEncuesta() {
      try {
        let resultado = await this.$apollo.mutate({
          mutation: REVISAR_ENCUESTA,
          variables: {
            id_encuesta: this.selectedEncuesta
          }
        });
        console.log(resultado);
        this.$apollo.queries.encuestas.refetch();
        this.$q.notify({
          position: "top-right",
          message: "La encuesta se ha revisado correctamente",
          color: "positive"
        });
      } catch (e) {
        this.$q.notify({
          position: "top-right",
          message: "Ha habido un error al revisar la encuesta",
          color: "negative"
        });
      }
    },
    readEncuesta(row) {
      switch (row.tipo_encuesta.tipo) {
        case "RAPID3":
          this.$router.push({
            path: `/encuestas/${row.id}/rapid3`,
            query: { readOnly: true }
          });
          return;
        case "BASDAI":
          this.$router.push({
            path: `/encuestas/${row.id}/rapid3`,
            query: { readOnly: true }
          });
          return;
      }
    },
    computedDate(d) {
      const comDat = d ? date.extractDate(d, "YYYY-MM-DD HH:mm:ss") : null;
      return comDat ? date.formatDate(comDat, "DD/MM/YYYY HH:mm") : "-";
    },
    calculateRowColor(row) {
      switch (row.estado_encuesta.nombre) {
        case "PENDIENTE":
          return "deep-orange";
        case "COMPLETADA":
          return "positive";
        case "REVISADA":
          return "primary";
      }
    },
    showBottomSheet(evt, row) {
      if (this.$q.screen.lt.md) {
        const actions = [];
        if (row.estado_encuesta.nombre === "COMPLETADA") {
          actions.push({
            label: "Marcar Encuesta como Revisada",
            icon: "check",
            id: "revisarEncuesta",
            classes: "custom-color-sheet"
          });
        }
        actions.push({
          label: "Ver Encuesta",
          icon: "history",
          id: "verEncuesta",
          classes: "custom-color-sheet"
        });
        this.$q
          .bottomSheet({
            message: "Seleccione una acción: ",
            grid: false,
            actions: actions
          })
          .onOk(action => {
            switch (action.id) {
              case "revisarEncuesta":
                this.showConfirmRevisarEncuesta(row);
                break;
              case "verEncuesta":
                this.readEncuesta(row);
                break;
            }
          });
      }
    }
  }
};
